/**
 * The Faq container
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Card, CardTitle, CardBody, CardImg, CardText } from 'reactstrap';
import { Link } from "react-router-dom";
import icon_info from '../../assets/images/icons/perks/info.svg'

/**
 * The `show` container for an Faq.
 * Both the component and the connected component are exported for testing purpose
 */
export class FaqView extends Component {

  /**
   * renders the faq data
   */
  render() {
      const { faq } = this.props;
    
    return (
      <Container>
        <header>
          <Link className="back-link" to={`/${faq.language}/faqs/${faq.faq_category.slug}/`}>&laquo; {this.context.t('go back to faq category')}</Link> | 
          <Link className="back-link" to={`/${faq.language}/faqs/`}>{this.context.t('go to support center')}</Link>
          <h1 className="my-4 h2">{faq.question}</h1>
        </header>
        <Row>
          <Col md={8}>
            <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
            <p><Link className="back-link" to={`/${faq.language}/faqs/${faq.faq_category.slug}/`}>&laquo; {this.context.t('go back to faq category')}</Link></p>
            { faq.related_questions &&
              <>
                <h2>{this.context.t('related questions')}</h2>
                <ul>
                  { faq.related_questions.map(faq =>
                    <li>
                      <Link to={`/${faq.language}/faq/${faq.slug}/`}>
                        {faq.question}
                      </Link>
                    </li>
                  )}
                </ul>
              </>
            }
          </Col>
          <Col md={4}>
            <Card className="faq-contactform">
              <CardImg top src={ icon_info } alt={this.context.t('further assistance needed?')} />
              <CardBody>
                <CardTitle>{this.context.t('further assistance needed?')}</CardTitle>
                <CardText>{this.context.t('If you are still having troubles feel free to contact us through our contact form or chat (if an agent is available)')}</CardText>
                { /*<Link to={`/${faq.language}/kontakt/`}>{this.context.t('contact support')}</Link>*/}
                <a href={`/${faq.language}/kontakt/`}>{this.context.t('contact support')}</a>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

    );
  }
}

/**  define proptype for the 'translation' function  */
FaqView.contextTypes = {
  t: PropTypes.func,
}

/** export the redux connected component and add a frontload call */
export default FaqView;